import { render, staticRenderFns } from "./ecard_after_sale.vue?vue&type=template&id=e6031a30"
import script from "./ecard_after_sale.vue?vue&type=script&lang=js"
export * from "./ecard_after_sale.vue?vue&type=script&lang=js"
import style0 from "./ecard_after_sale.vue?vue&type=style&index=0&id=e6031a30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports